import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 15 15",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.242 1.172h-.703V0h-1.172v1.172H3.633V0H2.46v1.172h-.703A1.76 1.76 0 000 2.93v10.312C0 14.212.789 15 1.758 15h11.484A1.76 1.76 0 0015 13.242V2.93a1.76 1.76 0 00-1.758-1.758zm.586 12.07a.587.587 0 01-.586.586H1.758a.587.587 0 01-.586-.586V5.508h12.656v7.734zm0-8.906H1.172V2.93c0-.323.263-.586.586-.586h.703v1.172h1.172V2.344h7.734v1.172h1.172V2.344h.703c.323 0 .586.263.586.586v1.406z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.398 6.738H2.227V7.91h1.171V6.738zM5.742 6.738H4.57V7.91h1.172V6.738zM8.086 6.738H6.914V7.91h1.172V6.738zM10.43 6.738H9.258V7.91h1.172V6.738zM12.773 6.738h-1.171V7.91h1.171V6.738zM3.398 9.082H2.227v1.172h1.171V9.082zM5.742 9.082H4.57v1.172h1.172V9.082zM8.086 9.082H6.914v1.172h1.172V9.082zM10.43 9.082H9.258v1.172h1.172V9.082zM3.398 11.426H2.227v1.172h1.171v-1.172zM5.742 11.426H4.57v1.172h1.172v-1.172zM8.086 11.426H6.914v1.172h1.172v-1.172zM10.43 11.426H9.258v1.172h1.172v-1.172zM12.773 9.082h-1.171v1.172h1.171V9.082z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }